<template>
  <div id="map">
    <div id="myChart" class="echart"></div>
  </div>
</template>

<script>
import mapData from "./map";
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {
    this.drawMap();
  },
  watch: {},
  methods: {
    drawMap() {
      this.$echarts.registerMap("changsanjiao", mapData.changsanjiaoMapJson);
      var myChart = this.$echarts.init(document.getElementById("myChart"));
      // 基于准备好的dom，初始化echarts实例
      // 绘制图表
      myChart.setOption({
        tooltip: false,
        geo: {
          show: true,
          map: "changsanjiao",
          layoutCenter: ["50%", "50%"],
          layoutSize: "100%",
          label: {
            normal: { show: false, color: "#696969" },
            emphasis: { show: false },
          },
          roam: false,
          itemStyle: {
            //区域图的背景色
            normal: {
              color: "#EBEEF2",
              borderColor: "rgba(255,255,255,1)",
              borderWidth: "1",
            },
            emphasis: { color: "#ABE2EF" }, //鼠标移入的背景色
          },
        },
        series: [
          {
            name: "上海",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: [{ name: "上海站", value: [121.462056, 31.255923] }],
            showEffectOn: "emphasis",
            rippleEffect: { brushType: "stroke", color: "#48BCBC" },
            hoverAnimation: false,
            label: {
              normal: {
                position: "top",
                show: true,
                backgroundColor: "#48BCBC",
                borderRadius: 4,
                padding: [5, 10],
                fontSize: 12,
                width: 80,
                height: 30,
                verticalAlign: "middle",
                align: "center",
                distance: 20,
                color: "#ffffff",
                formatter: "{b}",
              },
              emphasis: { color: "#fff", position: "top" },
            },
            itemStyle: {
              normal: {
                color: "#E4F4F4",
                borderWidth: 2,
                borderColor: "#48BCBC",
              },
            },
          },
          {
            name: "江苏省",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: [
              { name: "南京站", value: [118.803714, 32.093502] },
              { name: "南京南站", value: [118.804341, 31.975024] },
              { name: "苏州站", value: [120.617116, 31.335936] },
              { name: "无锡站", value: [120.312139, 31.592811] },
              { name: "常州站", value: [119.979708, 31.791408] },
              { name: "淮安站", value: [119.039811, 33.654743] },
              { name: "盐城站", value: [120.191462, 33.379424] },
              { name: "宿迁站", value: [118.288598, 33.879791] },
              { name: "连云港站", value: [119.169381, 34.61548] },
              { name: "徐州站", value: [117.213901, 34.271277] },
              { name: "徐州东站", value: [117.311767, 34.273338] },
            ],
            showEffectOn: "emphasis",
            rippleEffect: { brushType: "stroke", color: "#48BCBC" },
            hoverAnimation: false,
            label: {
              normal: {
                position: "top",
                show: true,
                fontSize: 12,
                backgroundColor: "#48BCBC",
                borderRadius: 4,
                padding: [5, 10],
                width: 80,
                height:30,
                verticalAlign: "middle",
                align: "center",
                distance: 20,
                color: "#ffffff",
                formatter: "{b}",
              },
              emphasis: { color: "#fff", position: "top" },
            },
            itemStyle: {
              normal: {
                color: "#E4F4F4",
                borderWidth: 2,
                borderColor: "#48BCBC",
              },
              
            },
          },
          {
            name: "浙江省",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: [
              { name: "杭州站", value: [120.189606, 30.249207] },
              { name: "杭州东站", value: [120.219396, 30.297149] },
              { name: "宁波站", value: [121.542826, 29.867603] },
              { name: "绍兴站", value: [120.585888, 30.020511] },
              { name: "嘉兴站", value: [120.770048, 30.770241] },
              { name: "余姚北站", value: [121.17481, 30.104552] },
            ],
            showEffectOn: "emphasis",
            rippleEffect: { brushType: "stroke", color: "#48BCBC" },
            hoverAnimation: false,
            label: {
              normal: {
                position: "top",
                show: true,
                fontSize: 12,
                backgroundColor: "#48BCBC",
                borderRadius: 4,
                padding: [5, 10],
                width: 80,
                height: 30,
                verticalAlign: "middle",
                align: "center",
                distance: 20,
                color: "#ffffff",
                formatter: "{b}",
              },
              emphasis: { color: "#fff", position: "top" },
            },
            itemStyle: {
              normal: {
                color: "#E4F4F4",
                borderWidth: 2,
                borderColor: "#48BCBC",
              },
            },
          },
          {
            name: "安徽省",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: [
              { name: "合肥站", value: [117.323619,31.891059] },
              { name: "安庆站", value: [117.07207,30.554889] },
            ],
            showEffectOn: "emphasis",
            rippleEffect: { brushType: "stroke", color: "#48BCBC" },
            hoverAnimation: false,
            label: {
              normal: {
                position: "top",
                show: true,
                fontSize: 12,
                backgroundColor: "#48BCBC",
                borderRadius: 4,
                padding: [5, 10],
                width: 80,
                height: 30,
                verticalAlign: "middle",
                align: "center",
                distance: 20,
                color: "#ffffff",
                formatter: "{b}",
              },
              emphasis: { color: "#fff", position: "top" },
            },
            itemStyle: {
              normal: {
                color: "#E4F4F4",
                borderWidth: 2,
                borderColor: "#48BCBC",
              },
            },
          },
        ],
      });
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
#map {
  height: 100%;
  width: 100%;
  .echart {
    width: 70rem;
    height: 70rem;
  }
   @media screen and (max-width: 414px) {
       .echart {
            width: 30rem;
            height: 40rem;
        }
   }

   @media screen and (max-width: 320px) {
       .echart {
            width: 24rem;
            height: 37rem;
        }
   }
}
</style>
